// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as StageLabRouteImport } from './routes/stage-lab'
import { Route as ShotRouteImport } from './routes/shot'
import { Route as RegulaminRouteImport } from './routes/regulamin'
import { Route as PolitykaPrywatnosciRouteImport } from './routes/polityka-prywatnosci'
import { Route as MeRouteImport } from './routes/me'
import { Route as GeomshotRouteImport } from './routes/geomshot'
import { Route as ComparisonRouteImport } from './routes/comparison'
import { Route as ArLaunchRouteImport } from './routes/ar-launch'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutIndexRouteImport } from './routes/checkout.index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as PreviewJobIdRouteImport } from './routes/preview.$jobId'
import { Route as OrderTokenRouteImport } from './routes/order.$token'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as CheckoutCancelRouteImport } from './routes/checkout.cancel'
import { Route as AuthEmailRouteImport } from './routes/auth.email'

const UploadRoute = UploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => rootRouteImport
          })
const StageLabRoute = StageLabRouteImport.update({
            id: '/stage-lab',path: '/stage-lab',getParentRoute: () => rootRouteImport
          })
const ShotRoute = ShotRouteImport.update({
            id: '/shot',path: '/shot',getParentRoute: () => rootRouteImport
          })
const RegulaminRoute = RegulaminRouteImport.update({
            id: '/regulamin',path: '/regulamin',getParentRoute: () => rootRouteImport
          })
const PolitykaPrywatnosciRoute = PolitykaPrywatnosciRouteImport.update({
            id: '/polityka-prywatnosci',path: '/polityka-prywatnosci',getParentRoute: () => rootRouteImport
          })
const MeRoute = MeRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => rootRouteImport
          })
const GeomshotRoute = GeomshotRouteImport.update({
            id: '/geomshot',path: '/geomshot',getParentRoute: () => rootRouteImport
          })
const ComparisonRoute = ComparisonRouteImport.update({
            id: '/comparison',path: '/comparison',getParentRoute: () => rootRouteImport
          })
const ArLaunchRoute = ArLaunchRouteImport.update({
            id: '/ar-launch',path: '/ar-launch',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
            id: '/checkout/',path: '/checkout/',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => rootRouteImport
          })
const PreviewJobIdRoute = PreviewJobIdRouteImport.update({
            id: '/preview/$jobId',path: '/preview/$jobId',getParentRoute: () => rootRouteImport
          })
const OrderTokenRoute = OrderTokenRouteImport.update({
            id: '/order/$token',path: '/order/$token',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
            id: '/checkout/cancel',path: '/checkout/cancel',getParentRoute: () => rootRouteImport
          })
const AuthEmailRoute = AuthEmailRouteImport.update({
            id: '/auth/email',path: '/auth/email',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ArLaunchRoute: ArLaunchRoute,ComparisonRoute: ComparisonRoute,GeomshotRoute: GeomshotRoute,MeRoute: MeRoute,PolitykaPrywatnosciRoute: PolitykaPrywatnosciRoute,RegulaminRoute: RegulaminRoute,ShotRoute: ShotRoute,StageLabRoute: StageLabRoute,UploadRoute: UploadRoute,AuthEmailRoute: AuthEmailRoute,CheckoutCancelRoute: CheckoutCancelRoute,CheckoutSuccessRoute: CheckoutSuccessRoute,OrderTokenRoute: OrderTokenRoute,PreviewJobIdRoute: PreviewJobIdRoute,ProjectsProjectIdRoute: ProjectsProjectIdRoute,ShareTokenRoute: ShareTokenRoute,CheckoutIndexRoute: CheckoutIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)